import { z } from "zod";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";
import { zNote, zObjectId } from "@dobrh-monorepo/core";

const requestSchema = z.object({
  _id: zObjectId().optional(),
  title: z.string().max(120),
  sharedWith: zObjectId().array(),
  tags: z.string().max(60).array(),
  plainText: z.string().max(10000),
  text: z.string().max(10000),
});

const responseSchema = zNote;

export default {
  method: HttpMethodEnum.POST,
  paramsType: HttpParamsTypeEnum.BODY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseSchema,
} satisfies Route;
